import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const cancelMessages = {
  en: "Payment was not completed.",
  fr: "Le paiement n'a pas été finalisé.",
  es: "El pago no se completó.",
  de: "Die Zahlung wurde nicht abgeschlossen.",
  it: "Il pagamento non è stato completato.",
  pt: "O pagamento não foi concluído.",
  nl: "De betaling is niet voltooid.",
  ru: "Платеж не был завершен.",
  zh: "付款未完成。",
  ja: "支払いが完了しませんでした。",
  ko: "결제가 완료되지 않았습니다.",
  ar: "لم تكتمل عملية الدفع.",
};

const retryLabels = {
  en: "Try again",
  fr: "Réessayer",
  es: "Intentar de nuevo",
  de: "Erneut versuchen",
  it: "Riprova",
  pt: "Tentar novamente",
  nl: "Opnieuw proberen",
  ru: "Попробовать снова",
  zh: "重试",
  ja: "再試行",
  ko: "다시 시도",
  ar: "حاول مجددا",
};

const CancelPage = () => {
  const navigate = useNavigate();
  const [lang, setLang] = useState("en");

  useEffect(() => {
    const code = (navigator.language || "en").split("-")[0];
    setLang(cancelMessages[code] ? code : "en");
  }, []);

  const handleRetry = () => {
    const teamId = localStorage.getItem("LastTeamId");
    const storedUser = localStorage.getItem("lastTipUser");

    if (storedUser) {
      try {
        // If we have a stored user context, go back to their page
        // (userId stored separately if available)
        const userId = localStorage.getItem("lastTipUserId");
        if (userId) {
          navigate(`/user/${userId}`);
          return;
        }
      } catch (_) {}
    }

    if (teamId) {
      navigate(`/team/${teamId}/members`);
    } else {
      navigate("/");
    }
  };

  return (
    <div className="min-h-screen bg-modern flex flex-col items-center justify-center px-6 py-12">
      <motion.div
        initial={{ opacity: 0, scale: 0.85 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
        className="w-full max-w-sm flex flex-col items-center text-center"
      >
        {/* Icône annulation */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.15, type: "spring", stiffness: 220, damping: 14 }}
          className="w-20 h-20 md:w-24 md:h-24 bg-gray-100 border-2 border-gray-200 rounded-full flex items-center justify-center mb-6"
        >
          <svg className="w-10 h-10 md:w-12 md:h-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </motion.div>

        {/* Titre */}
        <motion.h1
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="text-2xl md:text-3xl font-bold text-black mb-2"
        >
          {lang === "fr" ? "Paiement annulé" : lang === "es" ? "Pago cancelado" : lang === "de" ? "Zahlung abgebrochen" : "Payment cancelled"}
        </motion.h1>

        {/* Message */}
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="text-gray-500 text-sm md:text-base mb-8 px-2"
        >
          {cancelMessages[lang]}
        </motion.p>

        {/* Bouton réessayer */}
        <motion.button
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          onClick={handleRetry}
          className="w-full bg-black text-white font-bold py-4 px-6 rounded-2xl shadow-lg hover:bg-gray-800 active:scale-[0.98] transition text-base md:text-lg"
        >
          {retryLabels[lang]}
        </motion.button>
      </motion.div>
    </div>
  );
};

export default CancelPage;
